import {Component} from "@angular/core";
import {provideEntityModel, provideReportModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {ReceiveOrderSearchModel} from "../receive-order-search.model";
import {ReceiveOrderEntityModel} from "../receive-order-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {ReceiveOrderReportModel} from "../../reports/receive-order-report/receive-order-report.model";

@Component({
    selector: "wbo-receive-order-search-page",
    templateUrl: "./receive-order-search-page.component.html",
    providers: [provideSearchModel(ReceiveOrderSearchModel), provideEntityModel(ReceiveOrderEntityModel), provideReportModel(ReceiveOrderReportModel)]
})
export class ReceiveOrderSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
